module.exports = __webpack_public_path__ + "assets/img/amiya-dark.03686e42.gif";